<div 
    class="btn-translate" 
    placement="right" 
    [ngbTooltip]="detailsTranslate"
    (click)="updateTranslations($event)"
>
    <!-- <fa-icon [icon]="['fas', 'globe']" ></fa-icon> -->
    <img src="assets/icons/translate.png" alt="" />
</div>

<ng-template #detailsTranslate>
    <div class="translate-list">
        <div class="line" *ngFor="let trans of translations">
            <div class="flag">
                <img [src]="trans.flag" alt="">
            </div>
            <div class="text">
                {{ trans.value || '??' }}
            </div>
        </div>
    </div>
  </ng-template>
